module.exports = __webpack_public_path__ + "static/media/gloob.c69b75b7.svg";